import { db } from './firebase';
import { doc, setDoc, updateDoc, serverTimestamp, collection, query, where, getDocs, addDoc } from 'firebase/firestore';

// Track page view
export const trackPageView = async (userId, pageName, metadata = {}) => {
  if (!userId) return;
  
  try {
    await addDoc(collection(db, 'analytics_pageviews'), {
      userId,
      pageName,
      timestamp: serverTimestamp(),
      metadata,
      userAgent: navigator.userAgent,
      screenSize: `${window.screen.width}x${window.screen.height}`,
      isMobile: /Mobile|Android|iPhone/i.test(navigator.userAgent)
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track feature interaction
export const trackEvent = async (userId, eventName, eventData = {}) => {
  if (!userId) return;
  
  try {
    await addDoc(collection(db, 'analytics_events'), {
      userId,
      eventName,
      eventData,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};

// Update user presence (online/offline)
export const updateUserPresence = async (userId, isOnline, currentPage = null) => {
  if (!userId) return;
  
  try {
    const presenceRef = doc(db, 'analytics_presence', userId);
    await setDoc(presenceRef, {
      userId,
      isOnline,
      currentPage,
      lastActive: serverTimestamp()
    }, { merge: true });
  } catch (error) {
    console.error('Error updating presence:', error);
  }
};

// Start session tracking
export const startSession = async (userId) => {
  if (!userId) return;
  
  const sessionId = `${userId}_${Date.now()}`;
  
  try {
    await setDoc(doc(db, 'analytics_sessions', sessionId), {
      userId,
      sessionId,
      startTime: serverTimestamp(),
      lastActivity: serverTimestamp(),
      isActive: true
    });
    
    return sessionId;
  } catch (error) {
    console.error('Error starting session:', error);
  }
};

// End session tracking
export const endSession = async (sessionId) => {
  if (!sessionId) return;
  
  try {
    await updateDoc(doc(db, 'analytics_sessions', sessionId), {
      endTime: serverTimestamp(),
      isActive: false
    });
  } catch (error) {
    console.error('Error ending session:', error);
  }
};

// Update session activity
export const updateSessionActivity = async (sessionId) => {
  if (!sessionId) return;
  
  try {
    await updateDoc(doc(db, 'analytics_sessions', sessionId), {
      lastActivity: serverTimestamp()
    });
  } catch (error) {
    console.error('Error updating session:', error);
  }
};